import { css, html, nothing } from 'lit'
import HHQuizElement from './element.js'

/**
 * Import all views
 */
import './views/intro.js'
import './views/question.js'
import './views/summary.js'
import './views/results.js'
import './views/not-found.js'

/**
 * Import all components
 */
import './components/header.js'
import './components/navigation.js'
import './components/progress-bar.js'
import './components/modal.js'
import './components/modal-close-warning.js'
import './components/modal-info.js'
import './components/question-input.js'
import './components/router-link.js'
import './components/router-view.js'
import './components/selected-products-order.js'
import './components/selected-products.js'
import './components/georgias-widget.js'
import './components/product-card.js'
import './components/product-card-description.js'

/**
 * Quiz app wrapper component
 */

class HHQuizApp extends HHQuizElement {
  static properties = {
    handle: { type: String },
    inline: { type: Boolean },
    id: { type: String },
    results: { type: Object },
  }

  /**
   * Bootstraps APP
   * - Bootstrap store
   */
  connectedCallback() {
    super.connectedCallback()
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    })
    this.id = params.id ?? this.id
    this.store.isInline = !!this.inline
    this.store.isStatic = !!this.inline
    this.router.path =
      this.inline && (this.id || this.results)
        ? `/summary/${
            this.results?.json?.resultsHandle ??
            this.results?.resultsHandle ??
            this.id
          }`
        : this.router.path
    this.store.bootstrapQuiz(this.handle, this.results ?? this.id)
    document.addEventListener('toggleCart', this.openCart.bind(this))

    window.HH_QUIZ.openModal = (modalId) => {
      this.store.openModal(modalId)
    }
  }

  openCart(e) {
    e?.detail?.event?.preventDefault()
    document
      .querySelector('body')
      .classList.add('scroll-lock', 'mini-cart-is-active')
    document.querySelector('.js-overlay').classList.add('active')

    utils.pauseAllMedia()
    if (e.detail.key == 'notification') {
      document
        .querySelectorAll('hh-cart-notification')
        ?.forEach((el) => el.close())
    }
  }

  /**
   * Renders the current route
   * @returns {TemplateResult}
   */
  render() {
    return this.store.isReady
      ? html`
          <div class="hh-quiz ${this.store.isInline ? 'is-inline' : ''}">
            ${this.store.isInline
              ? nothing
              : html`<div class="hh-quiz__header">
                  <hh-quiz-header></hh-quiz-header>
                </div>`}
            <div class="hh-quiz__body">
              <hh-quiz-router-view></hh-quiz-router-view>
            </div>
          </div>
          ${this.store.isInline
            ? nothing
            : html`<hh-quiz-modal-close-warning></hh-quiz-modal-close-warning>`}
          <hh-quiz-modal-info></hh-quiz-modal-info>
          <hh-quiz-modal-background></hh-quiz-modal-background>
        `
      : ''
  }

  static styles = [
    HHQuizElement.styles,
    css`
      :host {
        opacity: 1 !important;
        background: var(--hh-color-sundrenched-stone);
      }
      .hh-quiz {
        display: flex;
        flex-direction: column;
        min-height: calc(100vh - 212px);
      }

      .hh-quiz.is-inline {
        padding-top: 20px !important;
        min-height: calc(100vh - 20px) !important;
      }

      @media screen and (max-width: ${HHQuizElement.mq.xs}px) {
        .hh-quiz {
          min-height: calc(100vh - 178px);
        }
      }

      .hh-quiz__header {
        position: sticky;
        top: 0;
        background: var(--hh-color-sundrenched-stone);
        z-index: calc(var(--hh-z-highest) * 2);
      }

      .hh-quiz__body {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
      }
    `,
  ]
}

customElements.define('hh-quiz-app', HHQuizApp)
